<section class="promo-categories">
  <div class="promo-categories__title">
    {{ 'HOME.HOME_PAGE.PROMO_TITLE' | translate }}
  </div>
  <!-- nested categories of promo drop-down menu -->
  <div class="promo-categories__promo-links">
    <div class="promo-categories__promo-links__link-container">
      <div class="promo-categories__promo-links__children">
        <a
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          (click)="loadMenuItemClickEvent(selectedCategory?.name); this.closeMenu(); genericNavigateTo(landingPagePath + '/' + allOffersLandingPage)"
          class="promo-categories__promo-links__children__item promo-categories__promo-links__children__item__hardcoded"
        >
          <app-svg-all-offers></app-svg-all-offers>
          <span>
            {{ 'HOME.HOME_PAGE.HEADER.CATEGORIES.ALL_OFFERS' | translate }}
          </span>
        </a>
        <a
          *ngIf="isSuperSavingsEnable"
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          (click)="loadMenuItemClickEvent('Super Savings'); this.closeMenu(); genericNavigateTo(contentPagePath + '/' + promoContentPage)"
          class="promo-categories__promo-links__children__item promo-categories__promo-links__children__item__hardcoded"
        >
          <app-svg-super-savings></app-svg-super-savings>
          <span>
            {{ superSavingsCategory.name }}
          </span>
        </a>
        <ng-container *ngFor="let nested of selectedCategory.children; let i = index">
          <a
            fxLayout="column"
            *ngIf="i < MAX_VISIBLE_PROMOTIONS_MENU_ITEMS_COUNT"
            (click)="loadMenuItemClickEvent(nested?.name); this.closeMenu(); genericNavigateTo(categoryPath + '/' + nested?.slug, { 'f.promotion': true })"
            class="promo-categories__promo-links__children__item"
            [mmTestTarget]="'nested-category-link'"
          >
            {{ nested?.name }}
          </a>
        </ng-container>
      </div>
      <app-editorial-link-list
        *ngIf="editorialList"
        [editorialList]="editorialList"
        (navigateTo)="genericNavigateTo($event)"
        (menuClosed)="closeMenu()"
      ></app-editorial-link-list>
    </div>

    <app-menu-navigation-banner
      *ngIf="thematicResources"
      [thematicResources]="thematicResources"
      (navigateTo)="genericNavigateTo($event)"
      (menuClosed)="closeMenu()"
    ></app-menu-navigation-banner>
  </div>
</section>
